import { z } from '@hono/zod-openapi'
import { zSelectBenefit } from '../benefit/benefit.zod'
import { zPassword } from '../common/common.model'
import { zSelectServiceProviderCategory } from '../service-provider-category/service-provider-category.zod'
import { zSelectUser } from '../user/user.zod'
import { zQueryVendors, zSelectVendor } from './vendor.zod'

export const zRegisterVendor = z.object({
    firstName: z.string().min(1, { message: 'First name is required' }),
    lastName: z.string().min(1, { message: 'Last name is required' }),
    email: z.email().trim().toLowerCase(),
    password: zPassword,
    organizationName: z
        .string()
        .min(1, { message: 'Organization name is required' }),
    categoryId: z.string().min(1, { message: 'Category is required' }),
    description: z.string().optional(),
    contactPhone: z.string().optional(),
    contactEmail: z.email().trim().toLowerCase(),
})

export const zUpdateVendorStatus = zQueryVendors.pick({ status: true })

export type RegisterVendor = z.infer<typeof zRegisterVendor>
export type UpdateVendorStatus = z.infer<typeof zUpdateVendorStatus>

export const zVendorDetails = zSelectVendor.extend({
    category: zSelectServiceProviderCategory.nullable(),
    users: z.array(zSelectUser),
    benefits: z.array(zSelectBenefit),
    vouchersCount: z.number(),
})

export type VendorDetails = z.infer<typeof zVendorDetails>
